import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { IconButton, Menu, MenuItem, Box, Tooltip } from '@mui/material';
import { CustomModal } from '../../../../components/CustomModal';
import { ReactComponent as MoreIcon } from '../../../../assets/images/more.svg';
import { ROUTES, getRouteWithParam } from '../../../../constants/routes';
import { deactivateUser, activateUser } from '../../../../store/user/actions';
import { DISABLED_CONTROL_TOOLTIP } from '../../../../constants/variables';

export const MoreActions = ({ status, id, clientName, permissions, userId }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpenedMore = Boolean(anchorEl);
  const [isOpenModalActivate, setIsOpenModalActivate] = useState(false);
  const [isOpenModalDeactivate, setIsOpenModalDeactivate] = useState(false);

  const handleClick = (action) => {
    setAnchorEl(null);

    if (action === 'activate') {
      setIsOpenModalActivate(true);
    }
    if (action === 'deactivate') {
      setIsOpenModalDeactivate(true);
    }
  };

  const handleActiveUser = () => {
    setIsOpenModalActivate(false);
    dispatch(activateUser(id));
  };

  const handleDeactivateUser = () => {
    setIsOpenModalDeactivate(false);
    dispatch(deactivateUser(id));
  };

  const MenuItemWithTooltip = (title, MenuItem) => title ? <Tooltip title={title} arrow placement="right"><Box component="span">{MenuItem}</Box></Tooltip> : MenuItem;
  const isEditDisabled = !(permissions.update || (!permissions.update && userId === id));

  return (
    <Box>
      <IconButton
        aria-label="Действия с профилем пользователя"
        aria-haspopup="true"
        aria-expanded={isOpenedMore ? 'true' : undefined}
        onClick={(e) => setAnchorEl(e.currentTarget)}>
        <MoreIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={isOpenedMore}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        data-testid="MoreMenu"
      >
        {MenuItemWithTooltip(isEditDisabled ? DISABLED_CONTROL_TOOLTIP : null,
          <MenuItem
            component={RouterLink}
            to={{ pathname: userId === id ? ROUTES.EDIT_PROFILE : getRouteWithParam(ROUTES.TEAM_EDIT_PROFILE_PERSON, ':id', id), state: { from: location.pathname } }}
            onClick={() => setAnchorEl(null)}
            disabled={isEditDisabled}
          >
            Редактировать
          </MenuItem>
        )}

        { userId !== id && status === 'Заблокирован' && (
          MenuItemWithTooltip(!permissions.activate ? DISABLED_CONTROL_TOOLTIP : null,
            <MenuItem
              sx={{ color: 'success.main' }}
              onClick={() => handleClick('activate')}
              disabled={!permissions.activate}
            >
              Разблокировать
            </MenuItem>
          )
        )}

        { userId !== id && status === 'Активен' && (
          MenuItemWithTooltip(!permissions.deactivate ? DISABLED_CONTROL_TOOLTIP : null,
            <MenuItem
              sx={{ color: 'error.main' }}
              onClick={() => handleClick('deactivate')}
              disabled={!permissions.deactivate}
            >
              Заблокировать
            </MenuItem>
          )
        )}
      </Menu>
      <CustomModal
        opened={isOpenModalActivate}
        modalClose={() => setIsOpenModalActivate(false)}
        modalSubmit={handleActiveUser}
        text={`Вы уверены, что хотите разблокировать ${clientName}?`}
        cancelBtnName="Отмена"
        submitBtnName="Да"
        submitRoute={ROUTES.TEAM}
        data-testid="UnblockModal"
      />
      <CustomModal
        opened={isOpenModalDeactivate}
        modalClose={() => setIsOpenModalDeactivate(false)}
        modalSubmit={handleDeactivateUser}
        text={`Вы уверены, что хотите заблокировать ${clientName}?`}
        cancelBtnName="Отмена"
        submitBtnName="Да"
        submitRoute={ROUTES.TEAM}
        data-testid="BlockModal"
      />
    </Box>
  );
};

MoreActions.propTypes = {
  status: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  clientName: PropTypes.string.isRequired,
  permissions: PropTypes.object,
  userId: PropTypes.any,
};
